/** @typedef {Record<string, string>} Dict */
/** type {Dict} */
export default {
  "layout.skipToContent": "İçeriğe geç",

  "hero.title": "3D Modelini Yükle\nSaniyeler İçinde Fiyatını Gör",
  "hero.subtitle":
    "STL veya OBJ dosyanı yükle, baskı ayarlarını seç ve 3D baskı için anında tahmini fiyatı al.",

  "cta.upload": "Modelini Yükle",
  "cta.seePrice": "Fiyatını Gör",
  "cta.getQuote": "Teklif Al",

  "trust.instant": "Anlık fiyatlandırma",
  "trust.fast": "Hızlı üretim",
  "trust.delivery": "Türkiye geneli teslimat",
  "trust.quality": "Profesyonel baskı kalitesi",

  "how.eyebrow": "NASIL ÇALIŞIR",
  "how.title": "Nasıl Çalışır",
  "how.description": "Dosyanı yükle, baskı ayarlarını seç, fiyatını hemen gör.",
  "how.step1": "3D modelini yükle",
  "how.step2": "Baskı ayarlarını seç",
  "how.step3": "Anında fiyatını al",

  "price.title": "Tahmini Fiyat",
  "price.subtitle": "Bu fiyat seçtiğin baskı ayarlarına göre hesaplanır.",
  "price.question": "Bu modeli üretmemizi ister misin?",
  "price.cta": "🚀 Teklif Al",

  "quote.title": "Kişisel Teklifini Al",
  "quote.subtitle": "Sadece adın ve telefon numaran yeterli",
  "quote.submit": "Teklif Al",

  "success.title": "Talebin alındı 🚀",
  "success.subtitle": "En kısa sürede sana dönüş yapacağız.",

  "whatsapp.title": "Daha hızlı yanıt ister misin?",
  "whatsapp.cta": "💬 WhatsApp'tan yaz",
  "whatsapp.floatingMessage": "Merhaba, 3D baskı hizmetleri hakkında bilgi almak istiyorum.",

  "loading.title": "Modelin analiz ediliyor...",
  "loading.subtitle": "Hacim, ağırlık ve baskı süresi hesaplanıyor",

  "viewer.badge.preview": "Önizleme",
  "viewer.badge.live": "Canlı",
  "viewer.reset": "Sıfırla",
  "viewer.empty.title1": "Modelinizi yükleyin,",
  "viewer.empty.title2": "burada 3D önizleyin.",
  "viewer.empty.formats": "STL · OBJ · STEP · 3MF destekleniyor",
  "viewer.loading": "Model çözümleniyor…",
  "viewer.error.title": "Önizleme Hatası",
  "viewer.error.fallback": "Model render edilemedi.",
  "viewer.error.unsupportedFormat": "Desteklenmeyen format. STL / OBJ / STEP / 3MF yükleyin.",
  "viewer.error.readFailed": "Dosya okunamadı.",
  "viewer.error.parseFailed": "Model çözümlenemedi. Dosya bozuk olabilir.",
  "viewer.hint.rotate": "SOL TIK · Döndür",
  "viewer.hint.pan": "SAĞ TIK · Kaydır",
  "viewer.hint.zoom": "SCROLL · Yakınlaştır",
  "viewer.step.title": "STEP dosyası alındı",
  "viewer.step.body":
    "STEP dosyanız alındı. Önizleme şu anda STL ve OBJ dosyaları için destekleniyor. Teknik ekibimiz STEP dosyanızı inceleyip teklif hazırlayacaktır.",

  "viewer.3mf.title": "3MF dosyası alındı",
  "viewer.3mf.body":
    "3MF dosyanız analiz ediliyor. Tarayıcı önizlemesi STL ve OBJ için destekleniyor; fiyat tahmini kısa sürede hesaplanacak.",

  "ai.panel.title": "Model Analizi",
  "ai.panel.subtitle": "Otomatik ön değerlendirme",
  "ai.loading": "Analiz hazırlanıyor…",
  "ai.row.fileType": "Dosya türü",
  "ai.row.printability": "Baskı uygunluğu",
  "ai.row.method": "Önerilen yöntem",
  "ai.row.materials": "Önerilen malzeme",
  "ai.row.risks": "Risk notu",
  "ai.row.nextStep": "Sonraki adım",
  "ai.meta.section": "Teknik Meta",
  "ai.meta.dimensions": "Boyutlar",
  "ai.meta.volume": "Tahmini hacim",
  "ai.meta.triangles": "Üçgen (Mesh)",
  "ai.meta.orientation": "Önerilen yön",
  "ai.disclaimer":
    "Bu analiz ön değerlendirme amaçlıdır. Nihai üretim uygunluğu teknik inceleme sonrası netleşir.",
  "ai.supportRisk.low": "Düşük",
  "ai.supportRisk.medium": "Orta",
  "ai.supportRisk.high": "Yüksek",

  "nav.home": "Anasayfa",
  "nav.services": "Hizmetler",
  "nav.materials": "Malzemeler",
  "nav.portfolio": "Portföy",
  "nav.about": "Hakkımızda",
  "nav.contact": "İletişim",

  "lang.tr": "TR",
  "lang.en": "EN",
  "lang.switchAria.tr": "Dili Türkçe seç",
  "lang.switchAria.en": "Dili İngilizce seç",

  "header.uploadModel": "Modelini Yükle",
  "header.themeAriaToLight": "Açık temaya geç",
  "header.themeAriaToDark": "Koyu temaya geç",
  "header.theme.light": "Light",
  "header.theme.dark": "Dark",
  "header.theme.mobile.light": "Light tema",
  "header.theme.mobile.dark": "Dark tema",
  "header.menuAria": "menu",

  "footer.tagline": "Türkiye'nin mühendislik odaklı 3D baskı ve hızlı prototipleme platformu. Fikirden fiziksel parçaya, saatler içinde.",
  "footer.pages": "Sayfalar",
  "footer.contactSection": "İletişim",
  "footer.legalPrivacy": "Gizlilik Politikası",
  "footer.legalKvkk": "KVKK Aydınlatma Metni",
  "footer.legalTerms": "Kullanım Şartları",
  "footer.copyright": "Tüm hakları saklıdır.",
  "footer.madeIn": "Made in Türkiye · Kalite standartlarına uygun üretim",

  "cta.eyebrow": "Bir sonraki adım",
  "cta.headline.line1": "Dosyanı yükle.",
  "cta.headline.line2.bold": "Saatler içinde",
  "cta.headline.line3": "üretime başla.",
  "cta.body": "Mühendis ekibimiz teklifini 1–2 saat içinde hazırlar. Uygunsa aynı gün üretime alınır.",
  "cta.uploadModel": "Modelini Yükle",
  "cta.seePrice": "Fiyatını Gör",

  "home.heroEyebrow": "Türkiye · Anlık Teklif · 24 Saatte Üretim",
  "home.heroTitle1": "3D Modelini Yükle,",
  "home.heroTitle2": "30 Saniyede Fiyatını Gör",
  "home.heroSub":
    "Dosyanı yükle → saniyeler içinde fiyat bandını gör → gönder, 1–2 saat içinde kesin teklif al.",

  "home.heroCta.upload": "Modelini Yükle",
  "home.heroCta.price": "Fiyatını Gör",

  "home.heroLiveBadge": "CANLI ÜRETİM",
  "home.heroCard.line1": "Printer_07 · Batch #2841",
  "home.heroCard.line2": "PA12 prototip · %78 tamamlandı",

  "home.trust1": "Üretime hazır dosya kontrolü",
  "home.trust2": "Türkiye geneli kargo",
  "home.trust3": "1–2 saatte kesin teklif",
  "home.trust4": "NDA korumalı",

  "home.metrics.lead.label": "Ortalama Termin",
  "home.metrics.materials.label": "Malzeme & Renk",
  "home.metrics.projects.label": "Tamamlanan Proje",
  "home.metrics.shipping.label": "İl Teslimat",

  "home.how.eyebrow": "Nasıl çalışır",
  "home.how.title": "Üç adımda üretime hazır",
  "home.how.description": "Karmaşık süreçler yerine net bir akış. Yükleyin, teklifi alın, teslimatta alın.",
  "home.how.step": "Adım",
  "home.how.s1.title": "Modelini Yükle",
  "home.how.s1.desc": "STL, OBJ, STEP veya 3MF dosyanı sürükle bırak. Gerekli malzeme ve termini seç.",
  "home.how.s2.title": "Fiyatını Gör",
  "home.how.s2.desc": "Sistem modeline göre anlık fiyat bandı oluşturur. Kesin teklif ekibimiz tarafından kısa sürede netleştirilir.",
  "home.how.s3.title": "Üretim & Teslimat",
  "home.how.s3.desc": "Onay sonrası üretime başlar, Türkiye genelinde hızlı kargo ile teslim ederiz.",

  "home.services.eyebrow": "Hizmetlerimiz",
  "home.services.title": "Fikirden Parçaya. Tek Platformda.",
  "home.services.description":
    "FDM ve SLA reçine baskıdan küçük seri üretime kadar, mühendislik kalitesinde 3D üretim.",

  "home.why.eyebrow": "Neden {brand}",
  "home.why.title": "Tasarımdan teslime. Tek bir mühendislik ekibi.",
  "home.why.desc": "Sadece bir baskı servisi değil, projenizin partneriyiz.",
  "home.why.more": "Hakkımızda daha fazla",

  "home.feature1.title": "Hızlı Üretim",
  "home.feature1.desc": "48 saatte prototip. Aynı gün kurye seçeneği İstanbul içi.",
  "home.feature2.title": "Mühendislik Kalitesi",
  "home.feature2.desc": "Her dosya mühendis kontrolünden geçer.",
  "home.feature3.title": "Malzeme Danışmanlığı",
  "home.feature3.desc": "Projene en uygun malzeme ve teknoloji önerisi.",
  "home.feature4.title": "Net İletişim",
  "home.feature4.desc": "Tek kişi, tek kanal. WhatsApp veya e-posta.",
  "home.feature5.title": "Türkiye Geneli",
  "home.feature5.desc": "81 il teslimatı anlaşmalı kargo ile 24–72 saat.",
  "home.feature6.title": "Gizlilik & NDA",
  "home.feature6.desc": "Tüm projelerde NDA koruması, bulut depolamada şifreli dosya.",

  "home.materials.eyebrow": "Malzemeler",
  "home.materials.title": "Her proje için doğru malzeme.",
  "home.materials.all": "Tüm malzemeler",

  "home.material.inStock.yes": "Stokta Var",
  "home.material.inStock.no": "Stokta Yok",

  "home.portfolio.eyebrow": "Portföy",
  "home.portfolio.title": "Üretimden seçmeler.",
  "home.portfolio.all": "Tüm projeler",

  "home.marquee.1": "500+ baskı üretildi",
  "home.marquee.2": "Hızlı teslimat",
  "home.marquee.3": "Profesyonel kalite",
  "home.marquee.4": "Türkiye genelinde müşteri memnuniyeti",

  "home.trustBlock":
    "Türkiye genelinde müşterilere hizmet veriyoruz. Mühendislik ekipleri, startup'lar ve üretim firmaları {brand}'yi tercih ediyor.",

  "home.faq.eyebrow": "SSS",
  "home.faq.title": "Cevapları burada.",
  "home.faq.description": "En sık sorulan sorular ve net yanıtlar. Listede yoksa WhatsApp'tan yazabilirsiniz.",
  "home.faq.whatsappCta": "WhatsApp'tan sor",

  "quote.hero.eyebrow": "Teklif al",
  "quote.hero.line1": "Dosyanı yükle.",
  "quote.hero.highlight": "3D Önizle.",
  "quote.hero.line2": "Teklif al.",
  "quote.hero.sub":
    "STL veya OBJ için tarayıcı önizleme ve sunucu tarafı ön fiyat aralığı. STEP dosyaları teknik inceleme sonrası fiyatlandırılır. Ekibimiz 1–2 saat içinde döner.",

  "quote.upload.title": "3D modelini yükle",
  "quote.upload.sub": "Anında fiyat tahmini al — STL, OBJ, STEP veya 3MF.",
  "quote.upload.hint": "veya tıklayıp seç · max 100 MB",
  "quote.upload.badges.max": "max 100MB",

  "quote.uploaded": "Yüklendi",

  "quote.expect.stl": "STL → Anında fiyat hesaplanır",
  "quote.expect.obj": "OBJ → Yaklaşık fiyat hesaplanır",
  "quote.expect.step": "STEP → Teknik inceleme sonrası fiyatlandırılır",
  "quote.expect.3mf": "3MF → Anında fiyat hesaplanır",
  "quote.expect.stlRest": "Anında fiyat hesaplanır",
  "quote.expect.objRest": "Yaklaşık fiyat hesaplanır",
  "quote.expect.stepRest": "Teknik inceleme sonrası fiyatlandırılır",
  "quote.expect.3mfRest": "Anında fiyat hesaplanır",

  "quote.print.title": "Baskı ayarları",
  "quote.print.description":
    "Ön fiyat bu seçimlere göre hesaplanır; seçimleri değiştirdiğinizde fiyat STL/OBJ için yenilenir.",

  "quote.label.material": "Malzeme *",
  "quote.materialSuggest": "Öneri İstiyorum",

  "quote.label.infill": "İç doluluk %",
  "quote.label.walls": "Duvar sayısı",
  "quote.label.layer": "Baskı kalitesi / katman",
  "quote.label.quality": "Kalite profili",

  "quote.quality.Ekonomik": "Ekonomik",
  "quote.quality.Standart": "Standart",
  "quote.quality.Dayanıklı": "Dayanıklı",
  "quote.quality.Detaylı": "Detaylı",

  "quote.trust": "Dosyanız yalnızca teklif süreci için kullanılır ve gizli tutulur. Talep üzerine NDA imzalarız.",

  "quote.stats.response": "Ort. Yanıt",
  "quote.stats.responseVal": "1-2 saat",
  "quote.stats.start": "Üretim Başlangıç",
  "quote.stats.sameDay": "Aynı gün",
  "quote.stats.delivery": "Teslimat",
  "quote.stats.deliveryVal": "24-72 saat",
  "quote.stats.privacy": "Gizlilik",
  "quote.stats.nds": "NDA Korumalı",

  "quote.preview.hint":
    "Modelinizi önizleyin, detayları kontrol edin ve hızlı teklif alın.",

  "quote.funnel.title": "Bu modeli üretmemizi ister misin?",
  "quote.funnel.desc": "Kesin süre ve fiyat için bilgilerini bırak; teknik ekibimiz geri dönsün.",
  "quote.funnel.cta": "Teklif Al",

  "quote.form.title": "Sana özel fiyatı gönderelim",
  "quote.form.subtitle": "Sadece ad ve telefon yeterli. E-posta ve not opsiyonel.",

  "quote.field.fullName": "Ad Soyad",
  "quote.field.phone": "Telefon",
  "quote.field.email": "E-posta (isteğe bağlı)",
  "quote.field.quantity": "Adet (isteğe bağlı)",
  "quote.field.notes": "Not (isteğe bağlı)",

  "quote.submit.sending": "Gönderiliyor…",
  "quote.submit.cta": "Teklif Al",
  "quote.whatsappSend": "WhatsApp ile Gönder",
  "quote.footerNote": "Ad ve telefon zorunludur. Veriler yalnızca teklif sürecinde kullanılır.",

  "quote.placeholder.name": "Ali Yılmaz",
  "quote.placeholder.phone": "+90 5XX XXX XX XX",
  "quote.placeholder.email": "ali@firma.com",
  "quote.placeholder.notes": "Tolerans, termin, yüzey beklentisi…",

  "toast.priceReady": "Fiyatın hazır 🎉",
  "toast.needNamePhone": "Lütfen ad ve telefon bilgilerini doldur.",
  "toast.requestReceived": "Talebin alındı 🚀",
  "toast.errorGeneric": "Bir hata oluştu. Lütfen tekrar dene.",
  "toast.unsupportedFormat": "Desteklenmeyen format. Kabul edilen:",
  "toast.fileTooBig": "Dosya çok büyük (maks. 100MB)",
  "toast.priceUpdateFailed":
    "Fiyat güncellenemedi. Dosyayı tekrar seçmeyi veya daha sonra denemeyi deneyin.",
  "quote.3mf.settingsApplied": "3MF dosyasındaki baskı ayarları uygulandı",
  "quote.3mf.detectedTitle": "3MF ayarları algılandı",
  "quote.3mf.detectedSubtitle": "Bu fiyat dosyanın içindeki baskı ayarlarına göre hesaplandı.",
  "quote.3mf.detectedAccuracy": "Bu fiyat, 3MF dosyanızdaki gerçek baskı ayarlarıyla daha doğru hesaplanır.",
  "quote.3mf.updatedByUser": "Ayarlar kullanıcı tarafından güncellendi",
  "quote.3mf.overrideSubtitle":
    "Güncel fiyat aşağıdaki form seçimlerinize göre hesaplanır; liste 3MF dosyasında bulunan ilk değerleri gösterir.",
  "quote.3mf.overrideAccuracy": "Liste yalnızca referans içindir; aralık şu anda seçtiğiniz ayarlara göredir.",
  "quote.3mf.infill": "İç doluluk",
  "quote.3mf.walls": "Duvar",
  "quote.3mf.layer": "Katman",
  "quote.3mf.quality": "Kalite",

  "error.prefix": "",

  "quote.success.title": "Talebin alındı 🚀",
  "quote.success.byline": "Merhaba, {{name}}",
  "quote.success.helloPrefix": "Merhaba,",
  "quote.success.guest": "dostum",
  "quote.success.followup": "Ekibimiz en kısa sürede dönüş yapacak.",
  "quote.success.emailLabel": "Güncelleme adresin:",
  "quote.success.whatsappAsk": "Hemen WhatsApp'tan konuşmak ister misin?",
  "quote.success.home": "Anasayfa",
  "quote.success.whatsDone": "💬 Hemen Yaz",

  "price.card.title": "Tahmini Fiyat",
  "price.card.subtitle": "Bu fiyat seçtiğin baskı ayarlarına göre hesaplanır.",

  "price.badge.pending": "İnceleme gerekli",
  "price.badge.analyzingLabel": "Analiz ediliyor",

  "price.level.high": "Kesin tahmine yakın",
  "price.level.medium": "Tahmini",
  "price.level.low": "Yaklaşık tahmin",

  "price.fallback.noFile": "Dosya yüklediğinizde yaklaşık fiyat aralığı burada görünecek.",
  "price.fallback.analyzing":
    "Model analiz ediliyor, birkaç saniye içinde ön tahmini fiyat gösterilecek.",
  "price.fallback.pendingReview":
    "Bu model için en doğru fiyatı ekibimiz hesaplayıp sana iletecek.",
  "price.fallback.technicalReview": "Teknik inceleme sonrası fiyatlandırılacak.",

  "price.review.tooDetailed": "Model çok detaylı olduğu için teknik inceleme gerekiyor.",
  "price.review.timeout": "Analiz süresi aşıldı. Ekibimiz dosyayı kontrol edip size dönüş yapacak.",
  "price.review.generic3mf":
    "Bu 3MF dosyası için otomatik hacım veya mesh bilgisi alınamadı; teknik inceleme gerekiyor.",

  "price.3mf.reviewCardTitle": "Bu 3MF dosyası teknik inceleme gerektiriyor.",
  "price.3mf.reviewCardBody": "Ekibimiz dosyayı kontrol edip size dönüş yapacak.",

  "price.loading.title": "Model analiz ediliyor…",
  "price.loading.line1": "Hacim, gram ve süre tahmini hesaplanıyor",
  "price.loading.line2": "Bu işlem genelde birkaç saniye sürer",

  "price.range.label": "Yaklaşık aralık (KDV dahil)",

  "price.support.prefix": "Destek riski:",
  "price.support.low": "Düşük",
  "price.support.medium": "Orta",
  "price.support.high": "Yüksek",

  "price.hint.label": "İpucu:",
  "price.hint.body": "Daha uygun fiyat için iç doluluk oranını düşürebilirsin.",

  "price.cta.askProduce": "Bu modeli üretmemizi ister misin?",
  "price.cta.primary": "🚀 Hemen Teklif Al",
  "price.collapsible.title": "Bu fiyat nasıl hesaplandı?",

  "price.detail.infill": "İç doluluk",
  "price.detail.walls": "Duvar sayısı",
  "price.detail.layer": "Katman kalınlığı",
  "price.detail.material": "Malzeme",
  "price.detail.duration": "Süre tahmini",
  "price.detail.durationUnit": "saat",
  "price.detail.gram": "Gram tahmini",
  "price.detail.dimensions": "Boyutlar (örtü)",
  "price.detail.triangles": "Üçgen sayısı",

  "price.disclaimer":
    "Kesin fiyat; baskı süresi, destek ihtiyacı ve operatör kontrolünden sonra netleşir.",

  "price.sidebar.form": "Kesin teklif için",
  "price.sidebar.formBold": "tek tuş ile formu doldurun — teknik ekibimiz dönsün.",
  "price.sidebar.expertLead": "Uzmanına anında bağlan.",
  "price.sidebar.expertBtn": "Uzmanla WhatsApp'ta Görüş",

  "units.hours": "saat",
  "dash": "—",

  "contact.eyebrow": "İletişim",
  "contact.hero.row1": "Konuşalım.",
  "contact.hero.bold": "Fikrini parçaya",
  "contact.hero.rest": " dönüştürelim.",
  "contact.hero.sub":
    "En hızlı yanıt için WhatsApp. Detaylı projeler için aşağıdaki form ya da e-posta.",

  "contact.row.phone": "Telefon",
  "contact.row.email": "E-posta",
  "contact.row.whatsapp": "WhatsApp",
  "contact.row.address": "Adres",
  "contact.hours.title": "Çalışma saatleri",

  "contact.field.name": "Ad Soyad *",
  "contact.field.email": "E-posta *",
  "contact.field.phone": "Telefon",
  "contact.field.subject": "Konu",
  "contact.field.message": "Mesaj *",

  "contact.placeholder.subject": "Proje ön görüşmesi",
  "contact.placeholder.message": "Projeyi kısaca anlat…",

  "contact.submit.sending": "Gönderiliyor…",
  "contact.submit.cta": "Mesajı Gönder",
  "contact.whats.cta": "WhatsApp'tan yaz",

  "toast.contact.missing": "Lütfen isim, e-posta ve mesaj alanlarını doldur.",
  "toast.contact.ok": "Mesajın alındı. En kısa sürede dönüş yapacağız.",
  "toast.contact.fail": "Bir hata oluştu.",

  "materials.eyebrow": "Malzemeler",
  "materials.hero.line1": "Projen için",
  "materials.hero.highlight": "doğru malzeme.",
  "materials.hero.sub":
    "50+ malzeme seçeneği. Emin değilsen bir WhatsApp yeter, mühendis ekibimiz seni yönlendirir.",

  "materials.empty.desc":
    "Filtreleri değiştirerek tekrar deneyebilirsin. Liste yöneticiden güncellenince burada görünecek.",
  "materials.empty.home": "Ana sayfaya dön",

  "materials.compareTitle": "Karşılaştırma Tablosu",
  "materials.compareSubtitle": "Hangi malzeme sana uygun?",
  "materials.table.mat": "Malzeme",
  "materials.table.use": "Kullanım",
  "materials.table.heat": "Isı",
  "materials.table.strength": "Dayanım",
  "materials.table.detail": "Detay",

  "materials.row.pla.use": "Prototip / Maket",
  "materials.row.petg.use": "Fonksiyonel / Dış Mekan",
  "materials.row.abs.use": "Endüstriyel / Otomotiv",
  "materials.row.resin.use": "Takı / Dental / Mikro",
  "materials.row.nylon.use": "Endüstriyel Fonksiyonel",
  "materials.row.tpu.use": "Esnek / Conta",

  "materials.row.pla.strength": "Orta",
  "materials.row.petg.strength": "Yüksek",
  "materials.row.abs.strength": "Yüksek",
  "materials.row.resin.strength": "Orta",
  "materials.row.nylon.strength": "Çok Yüksek",
  "materials.row.tpu.strength": "Esnek",

  "materials.row.pla.detail": "Yüksek",
  "materials.row.petg.detail": "Yüksek",
  "materials.row.abs.detail": "Orta",
  "materials.row.resin.detail": "Çok Yüksek",
  "materials.row.nylon.detail": "Yüksek",
  "materials.row.tpu.detail": "Yüksek",

  "materials.stock.in": "Stokta Var",
  "materials.stock.out": "Stokta Yok",

  "services.eyebrow": "Hizmetler",
  "services.hero.line1": "Mühendislik kalitesinde",
  "services.hero.highlight": "3D üretim hizmetleri.",
  "services.hero.sub":
    "Hızlı prototipleme, fonksiyonel parçalar, mimari maketler ve küçük seri üretim. Tek bir platformda.",

  "services.detail.fdm.0": "0.1 mm katman çözünürlüğe kadar",
  "services.detail.fdm.1": "500 x 500 x 600 mm baskı hacmi",
  "services.detail.fdm.2": "PLA, PETG, ABS, ASA, Nylon, CF katkılı",
  "services.detail.resin.0": "25 mikron XY çözünürlük",
  "services.detail.resin.1": "Takı, dental, mikro parça",
  "services.detail.resin.2": "Tough, Flexible, Clear, Castable reçineler",
  "services.detail.prototype.0": "48 saat içinde fiziksel parça",
  "services.detail.prototype.1": "DFM ve tasarım danışmanlığı",
  "services.detail.prototype.2": "İteratif prototipleme döngüsü",
  "services.detail.functional.0": "Endüstriyel dayanım",
  "services.detail.functional.1": "Nylon PA12, CF katkılı malzemeler",
  "services.detail.functional.2": "Montaj ve sonrası işlem",
  "services.detail.architecture.0": "1:50 – 1:1000 ölçek",
  "services.detail.architecture.1": "Beyaz reçine veya FDM",
  "services.detail.architecture.2": "Peyzaj ve yapı detayı",
  "services.detail.batch.0": "10–1000 adet",
  "services.detail.batch.1": "Kalite kontrol raporu",
  "services.detail.batch.2": "Konsolide teslimat",

  "portfolio.eyebrow": "Portföy",
  "portfolio.hero.line1": "Üretimden",
  "portfolio.hero.highlight": "seçkiler.",
  "portfolio.hero.sub":
    "Endüstriyel parça, mimari maket, fonksiyonel prototip ve daha fazlası.",

  "portfolio.filter.all": "Tümü",
  "portfolio.empty.filter": "Filtreleri değiştirerek tekrar deneyebilirsin",
  "portfolio.empty.none": "Bu kategori için görüntülenecek proje yok; filtreyi değiştirin.",
  "portfolio.cmsEmpty": "Liste yöneticiden güncellenince projeler burada görünecek.",
  "portfolio.empty.resultsTitle": "Sonuç bulunamadı",

  "about.eyebrow": "Hakkımızda",
  "about.hero.line1": "Mühendis bakış açısıyla",
  "about.hero.highlight": "3D üretim.",
  "about.intro":
    "{brand}, makina mühendisleri ve ürün tasarımcılarının bir araya gelip kurduğu bir hızlı üretim atölyesidir. Sadece 3D baskı değil, fikri çalışır parçaya dönüştüren bir süreç sunarız.",

  "about.alt.main": "3D baskı",

  "about.pillar1.title": "Teknoloji Odaklı",
  "about.pillar1.body":
    "Endüstriyel FDM, SLA/DLP, SLS makina parkı ile çok çeşitli üretim ihtiyaçlarına cevap veriyoruz.",
  "about.pillar2.title": "Tasarım Mühendisliği",
  "about.pillar2.body":
    "DFM (Design for Manufacturing) danışmanlığı ile parçanı üretime hazır hale getiriyoruz.",
  "about.pillar3.title": "Tek Muhatap",
  "about.pillar3.body":
    "Projenle ilgilenen tek bir mühendis. Uzun cevap bekleme, tek bir WhatsApp ile her şey.",
  "about.pillar4.title": "Gizlilik",
  "about.pillar4.body": "NDA, şifreli dosya transferi ve rol bazlı erişim ile projeniz güvende.",

  "about.valuesEyebrow": "Değerlerimiz",
  "about.valuesTitle": "Hız, kalite, net iletişim. Her üçü bir arada.",

  "about.v1.title": "Hız",
  "about.v1.body": "Hızlı teklif, hızlı üretim, hızlı kargo. Zaman rekabet avantajıdır.",
  "about.v2.title": "Kalite",
  "about.v2.body": "Her parça kontrol edilir. Tolerans dışı parçaları göndermeyiz.",
  "about.v3.title": "İletişim",
  "about.v3.body": "Net yanıt, net termin. Belirsizlik yok.",

  "notfound.label": "Hata 404",
  "notfound.title": "Sayfa Bulunamadı",
  "notfound.body": "Aradığınız sayfa taşınmış ya da hiç var olmamış olabilir.",
  "notfound.home": "Anasayfaya Dön",

  "whatsapp.aria": "WhatsApp",
  "whatsapp.brand": "WhatsApp",

  "empty.defaults.title": "Sonuç bulunamadı",
  "empty.defaults.desc": "Filtreleri değiştirerek tekrar deneyebilirsin",
  "empty.defaults.action": "Tümünü göster",

  "price.whatsapp.prefill":
    "Merhaba — modelim yaklaşık {{volume}} cm³; ön fiyat görünümü {{low}} – {{high}}. Detay için uzmanla görüşmek istiyorum.",
  "price.whatsapp.prefill.generic":
    "Merhaba — 3D baskı projem için teknik görüşebilir miyiz?",

  "faq.whatsapp.intro": "Merhaba — sık sorulanlar listesinde cevap bulamadım.",

  "quote.whatsapp.intro": "Merhaba — teklif sürecinde WhatsApp üzerinden devam etmek istiyorum.",

  "quote.upload.whatsapp.intro":
    "Merhaba — DEKOSTA3D üzerinden model yüklemiştim.",

  "quote.success.wa.intro": "Merhaba — az önce web formundan gönderdim.",

  "marquee.sep": "|",
};
